var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "faq",
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.076,
    height: 91.987,
    viewBox: "0 0 92.076 91.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85371",
    "data-name": "Group 85371",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85363",
    "data-name": "Group 85363",
    transform: "translate(5.775 35.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85358",
    "data-name": "Group 85358",
    transform: "translate(0 26.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85356",
    "data-name": "Group 85356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241626",
    "data-name": "Path 241626",
    d: "M67.907,343.9H29.351V328.553a13.772,13.772,0,0,1,13.772-13.772H54.135a13.772,13.772,0,0,1,13.772,13.772Z",
    transform: "translate(-29.351 -314.781)",
    fill: "#ffdbb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85357",
    "data-name": "Group 85357",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241627",
    "data-name": "Path 241627",
    d: "M47.059,314.781H43.124a13.772,13.772,0,0,0-13.772,13.772V343.9h3.935V328.553A13.772,13.772,0,0,1,47.059,314.781Z",
    transform: "translate(-29.352 -314.781)",
    fill: "#fda639"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85359",
    "data-name": "Group 85359",
    transform: "translate(13.863 13.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241628",
    "data-name": "Path 241628",
    d: "M105.227,271.057a5.415,5.415,0,0,1-5.415-5.415V253.517a.718.718,0,0,1,.718-.718h9.4a.718.718,0,0,1,.718.718v12.125A5.415,5.415,0,0,1,105.227,271.057Z",
    transform: "translate(-99.812 -252.799)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85362",
    "data-name": "Group 85362",
    transform: "translate(8.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85360",
    "data-name": "Group 85360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241629",
    "data-name": "Path 241629",
    d: "M94.756,188.629A17.114,17.114,0,0,1,81.82,182.5l-.983,1.679a10.171,10.171,0,0,1-6.076,4.662v6.446A10.2,10.2,0,0,0,84.99,205.458h.23a10.2,10.2,0,0,0,10.229-10.175v-6.646Z",
    transform: "translate(-74.761 -182.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85361",
    "data-name": "Group 85361",
    transform: "translate(0 4.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241630",
    "data-name": "Path 241630",
    d: "M78.7,212.609v-8.543a10.2,10.2,0,0,1-3.935,2.1v6.446A10.2,10.2,0,0,0,84.99,222.785h.23a10.334,10.334,0,0,0,1.853-.17A10.191,10.191,0,0,1,78.7,212.609Z",
    transform: "translate(-74.761 -204.066)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85370",
    "data-name": "Group 85370",
    transform: "translate(49.016 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85368",
    "data-name": "Group 85368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85364",
    "data-name": "Group 85364",
    transform: "translate(0.984 0.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241631",
    "data-name": "Path 241631",
    d: "M272.937,5.225a18.745,18.745,0,0,0-18.8,18.691,18.524,18.524,0,0,0,2.836,9.874l-2.208,8.192,8.24-2.2a18.728,18.728,0,1,0,9.931-34.562Z",
    transform: "translate(-254.138 -5.225)",
    fill: "#ffdbb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85365",
    "data-name": "Group 85365",
    transform: "translate(17.815 0.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241632",
    "data-name": "Path 241632",
    d: "M341.656,5.225a19.117,19.117,0,0,0-1.967.1,18.681,18.681,0,0,1,0,37.177,19.127,19.127,0,0,0,1.965.1,18.691,18.691,0,1,0,0-37.381Z",
    transform: "translate(-339.689 -5.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85366",
    "data-name": "Group 85366",
    transform: "translate(0.984 0.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241633",
    "data-name": "Path 241633",
    d: "M258.073,23.916A18.733,18.733,0,0,1,274.9,5.327a19.117,19.117,0,0,0-1.967-.1,18.745,18.745,0,0,0-18.8,18.691,18.524,18.524,0,0,0,2.836,9.874l-2.208,8.192,4.239-1.129,1.9-7.063A18.523,18.523,0,0,1,258.073,23.916Z",
    transform: "translate(-254.138 -5.225)",
    fill: "#fda639"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85367",
    "data-name": "Group 85367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241634",
    "data-name": "Path 241634",
    d: "M268.921,39.574a19.82,19.82,0,0,1-10.082-2.745L251,38.916a.99.99,0,0,1-1.2-1.206l2.1-7.784a19.545,19.545,0,0,1-2.76-10.026,19.783,19.783,0,1,1,19.783,19.674Zm-9.413-4.639A17.838,17.838,0,0,0,286.736,19.9a17.816,17.816,0,0,0-35.63,0,17.579,17.579,0,0,0,2.685,9.351.983.983,0,0,1,.117.779l-1.764,6.547,6.593-1.757A.982.982,0,0,1,259.508,34.934Z",
    transform: "translate(-249.138 -0.225)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85369",
    "data-name": "Group 85369",
    transform: "translate(15.548 11.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241635",
    "data-name": "Path 241635",
    d: "M330.621,70.868l-.054-.707a6.24,6.24,0,0,1,1.694-4.711c1.229-1.443,1.912-2.5,1.912-3.729,0-1.39-.874-2.314-2.6-2.341a4.875,4.875,0,0,0-2.76.842l-.655-1.714a7.175,7.175,0,0,1,3.907-1.091c3.143,0,4.563,1.933,4.563,4,0,1.851-1.038,3.185-2.349,4.737a5.361,5.361,0,0,0-1.557,4l.027.707Zm-.6,3.813a1.612,1.612,0,0,1,1.64-1.716,1.7,1.7,0,1,1-1.64,1.716Z",
    transform: "translate(-328.163 -57.419)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_241636",
    "data-name": "Path 241636",
    d: "M91.092,184.653H45.314V170.291a14.731,14.731,0,0,0-5.452-11.442,7.57,7.57,0,0,0,3.233-6.184,7.45,7.45,0,0,0-1.507-4.519,7.529,7.529,0,0,0,.353-11.726V134.53c.193-8.976-8.1-16.97-17.036-16.77-8.926-.2-17.212,7.775-17.036,16.744l0,1.916a7.529,7.529,0,0,0,.354,11.726,7.45,7.45,0,0,0-1.507,4.519,7.569,7.569,0,0,0,3.393,6.291,14.73,14.73,0,0,0-5.321,11.335v14.361H.984a.984.984,0,1,0,0,1.967H91.092a.984.984,0,1,0,0-1.967ZM25.168,152.472a9.239,9.239,0,0,1-9.475-9.191v-5.723a11.251,11.251,0,0,0,6.246-5.408,18.073,18.073,0,0,0,12.475,5.455v5.675A9.229,9.229,0,0,1,25.168,152.472Zm4.316,1.106v3.59a4.431,4.431,0,0,1-8.863,0v-3.59A11.787,11.787,0,0,0,29.484,153.578Zm7.5,31.074V175.4a.984.984,0,0,0-1.967,0v9.248H15.09V175.4a.984.984,0,0,0-1.967,0v9.248H6.759V170.291A12.8,12.8,0,0,1,18.666,157.54a6.4,6.4,0,0,0,12.775,0,12.8,12.8,0,0,1,11.907,12.754v14.361Z",
    transform: "translate(0 -94.633)",
    fill: "#8e8e8e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85376",
    "data-name": "Group 85376",
    transform: "translate(61.778 46.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85372",
    "data-name": "Group 85372",
    transform: "translate(11.805 9.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241637",
    "data-name": "Path 241637",
    d: "M374.984,303.55a.984.984,0,0,1-.984-.984V284.975a.984.984,0,1,1,1.967,0v17.591A.984.984,0,0,1,374.984,303.55Z",
    transform: "translate(-374 -283.991)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85373",
    "data-name": "Group 85373",
    transform: "translate(11.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241638",
    "data-name": "Path 241638",
    d: "M374.984,243.167a.984.984,0,0,1-.984-.984v-3.209a.984.984,0,0,1,1.967,0v3.209A.984.984,0,0,1,374.984,243.167Z",
    transform: "translate(-374 -237.991)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85374",
    "data-name": "Group 85374",
    transform: "translate(0 16.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241639",
    "data-name": "Path 241639",
    d: "M314.984,343.55a.984.984,0,0,1-.984-.984V324.975a.984.984,0,1,1,1.967,0v17.591A.984.984,0,0,1,314.984,343.55Z",
    transform: "translate(-314 -323.991)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85375",
    "data-name": "Group 85375",
    transform: "translate(0 7.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241640",
    "data-name": "Path 241640",
    d: "M314.984,283.167a.984.984,0,0,1-.984-.984v-3.209a.984.984,0,1,1,1.967,0v3.209A.984.984,0,0,1,314.984,283.167Z",
    transform: "translate(-314 -277.991)",
    fill: "#8e8e8e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.0fcaa3627c12bca77490cfa0bf1adc91.svg";
export { ForwardRef as ReactComponent };